
const AboutUsPage = props => {
    return (
        <div>About us</div>
    )

}

export default AboutUsPage